export var encoder = {
	encodeUrlParam(param) {
		return typeof param === "string"
			? param.replace(/\+/g, "%2B").replace(/&/g, "%26")
			: param;
	},
};
